import { useContext } from "react";

import { UserContext } from "ui/app";

export function useUserContext() {
  return useContext(UserContext);
}
